/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import { IMPORT_COSTUME_TYPE } from "../graphql";
import frontlineTemplate from "../config/frontlineTemplate.config.json";
import backlineTemplate from "../config/backlineTemplate.config.json";
import maleTemplate from "../config/maleTemplate.config.json";
import femaleTemplate from "../config/femaleTemplate.config.json";

const is = require("is_js");
export interface IImportCostumeTypeArgs {
  presentationId: string;
  sectionId: string;
  dropDownValue: string;
}

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IImportCostumeTypeMethods extends IPluginMethodMap {
  importCostumeType(args: any): Promise<any>;
}

export class ImportCostumeType implements IAgentPlugin {
  readonly methods: IImportCostumeTypeMethods;

  constructor() {
    this.methods = {
      importCostumeType: this.importCostumeType.bind(this),
    };
  }

  async importCostumeType(args: IImportCostumeTypeArgs) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");

    let payload: any = {};

    if (args?.dropDownValue === "frontline") {
      payload = {
        ...frontlineTemplate,
      };
    } else if (args?.dropDownValue === "backline") {
      payload = {
        ...backlineTemplate,
      };
    } else if (args?.dropDownValue === "male") {
      payload = {
        ...maleTemplate,
      };
    } else if (args?.dropDownValue === "female") {
      payload = {
        ...femaleTemplate,
      };
    } else {
      throw new Error("Please select a valid Section Option Type.");
    }

    try {
      if (client) {
        const res = await client.query({
          query: IMPORT_COSTUME_TYPE,
          variables: {
            data: {
              presentation: args?.presentationId,
              section: args?.sectionId,
              ...payload,
            },
          },
          fetchPolicy: "no-cache",
        });

        if (res?.data?.importCostumeType) {
          return res?.data?.importCostumeType;
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
}
